import {Component, Input, AfterViewInit, OnChanges} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {DeviceParamGatewayV3OsmosLirisManager} from "../../../../../../shared/classes/device/type-gateway-v3/device-param-gateway-v3-osmos-liris-manager";

@Component({
    selector: 'app-param-osmos-liris-manager',
    templateUrl: './param-osmos-liris-manager.component.html',
    styleUrls: ['./param-osmos-liris-manager.component.css']
})
export class ParamOsmosLirisManagerComponent implements OnChanges {

    osmosLirisManagerForm: FormGroup;
    @Input('deviceParamGatewayV3OsmosLirisManager') deviceParamGatewayV3OsmosLirisManager: DeviceParamGatewayV3OsmosLirisManager;
    @Input('editable') editable: boolean = true;

    constructor() {
    }

    ngOnChanges() {
        if (!this.deviceParamGatewayV3OsmosLirisManager) return;
        if (this.osmosLirisManagerForm) return;
        this.osmosLirisManagerForm = new FormGroup({
            find_ble_liris_nb_discovery: new FormControl(this.deviceParamGatewayV3OsmosLirisManager.find_ble_liris.nb_discovery),
            find_ble_liris_max_err: new FormControl(this.deviceParamGatewayV3OsmosLirisManager.find_ble_liris.max_err),
            find_ble_liris_sleep_after_discovery: new FormControl(this.deviceParamGatewayV3OsmosLirisManager.find_ble_liris.sleep_after_discovery),
            find_ble_liris_wait_cmd: new FormControl(this.deviceParamGatewayV3OsmosLirisManager.find_ble_liris.wait_cmd),
            display: new FormControl(this.deviceParamGatewayV3OsmosLirisManager.display.trame),
            post_data: new FormControl(this.deviceParamGatewayV3OsmosLirisManager.post_data.nb_items)
        })
    }

    public setDeviceWithForm() {
        this.deviceParamGatewayV3OsmosLirisManager.find_ble_liris.nb_discovery = this.osmosLirisManagerForm.value.find_ble_liris_nb_discovery;
        this.deviceParamGatewayV3OsmosLirisManager.find_ble_liris.max_err = this.osmosLirisManagerForm.value.find_ble_liris_max_err;
        this.deviceParamGatewayV3OsmosLirisManager.find_ble_liris.sleep_after_discovery = this.osmosLirisManagerForm.value.find_ble_liris_sleep_after_discovery;
        this.deviceParamGatewayV3OsmosLirisManager.find_ble_liris.wait_cmd = this.osmosLirisManagerForm.value.find_ble_liris_wait_cmd;
        this.deviceParamGatewayV3OsmosLirisManager.display.trame = this.osmosLirisManagerForm.value.display;
        this.deviceParamGatewayV3OsmosLirisManager.post_data.nb_items = this.osmosLirisManagerForm.value.post_data;
    }

}
